<div class="row rounded-2 bg-card">
  <div class="col text-start mt-2 mb-2">
    <span class="fs-lg text-body-emphasis">{{ category?.title }}</span>
    @if (icon) {
      <i class="{{ icon }}" [ngStyle]="{ transform: 'rotate(' + bearing + 'deg)' }"></i>
    }
  </div>
</div>
<div class="row mt-2">
  @for (content of category?.items; track $index) {
    <app-details-item
      class="col-12 col-md-6 gy-2 gx-5"
      [description]="content.description"
      [value]="content.value"
      [unit]="content.unit"
      [blur]="content.blur"
    ></app-details-item>
  }
</div>
